import React from "react";
import { FireSimple, Warning } from "@phosphor-icons/react";

const STATUS_COLORS = {
  "Out of Control": "text-tac-danger",
  "Being Held": "text-amber-400",
  "Under Control": "text-tac-safe",
  New: "text-tac-primary",
};

function fmt(n) {
  if (n == null) return "—";
  return n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`;
}

export default function BcFiresCard({ fires = [], evacs = [] }) {
  return (
    <div className="border border-tac-border bg-tac-surface/40" data-testid="bc-fires-card">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-tac-border">
        <div className="flex items-center gap-2">
          <FireSimple size={13} weight="fill" className="text-[#C1121F]" />
          <span className="text-[15px] uppercase tracking-[0.15em] font-bold text-tac-faint">
            BC Wildfire Service
          </span>
        </div>
        <span className="text-[11px] font-mono-tac tabular text-tac-faint">{fires.length} active</span>
      </div>

      {evacs.length > 0 && (
        <div className="px-4 py-2 border-b border-tac-border/60 space-y-1" data-testid="bc-evacs-list">
          {evacs.map((e) => (
            <div key={e.id} className="flex items-center gap-2 text-xs">
              <Warning size={12} weight="fill" className={e.status === "Order" ? "text-tac-danger" : "text-amber-400"} />
              <span className={`font-bold uppercase ${e.status === "Order" ? "text-tac-danger" : "text-amber-400"}`}>
                Evac {e.status}
              </span>
              <span className="text-tac-text truncate">{e.zone_name || e.event_name}</span>
            </div>
          ))}
        </div>
      )}

      {fires.length === 0 ? (
        <p className="px-4 py-3 text-[13px] text-tac-faint">No active BCWS fires in the border region.</p>
      ) : (
        <ul className="divide-y divide-tac-border/40 max-h-64 overflow-y-auto">
          {fires.map((f) => (
            <li key={f.id} className="px-4 py-2" data-testid={`bc-fire-row-${f.id}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold text-tac-text truncate">
                  {f.name}
                  {f.fire_of_note && (
                    <span className="ml-1.5 text-[9px] font-bold uppercase text-tac-danger border border-tac-danger px-1 rounded-sm">Note</span>
                  )}
                </span>
                <span className="text-[11px] font-mono-tac tabular text-tac-dim shrink-0">
                  {fmt(f.size_ha)} ha
                </span>
              </div>
              <div className="flex items-center justify-between text-[11px]">
                <span className={`font-bold ${STATUS_COLORS[f.status] || "text-tac-dim"}`}>{f.status}</span>
                <span className="text-tac-faint">{f.fire_number}{f.cause ? ` · ${f.cause}` : ""}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
      <div className="px-4 py-1.5 text-[10px] font-mono-tac text-tac-faint border-t border-tac-border/40">
        Sources: BC Wildfire Service · EmergencyInfoBC
      </div>
    </div>
  );
}
